// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4ba873cb","732":"207fbb94"}[chunkId] + ".chunk.js";
};